<template>
	<div class="px-3 py-2 flex flex-col gap-1 hover:bg-gray-100 dark:hover:bg-gray-900 first:rounded-t last:rounded-b">
		<div class="flex flex-col items-stretch lg:flex-row lg:items-center gap-3">
			<slot name="icon"/>
			<div class="grow flex justify-between items-center gap-2">
				<div class="grow flex flex-col items-start">
					<p>{{ title }}</p>
					<p v-if="subtitle" class="text-sm text-gray-500">{{ subtitle }}</p>
				</div>
				<div v-if="$slots.accessory">
					<slot name="accessory"/>
				</div>
			</div>
		</div>
		<slot/>
	</div>
</template>
<script setup lang="ts">
import {defineProps} from 'vue'

defineProps<{
	title:string,
	subtitle?:string,
}>()
</script>
